module.exports = {"id":"226379","name":"Marcos Díaz","rating":"76","photo":"./data/images/photos/0/226379.png","club":{"name":"Parque Patricios","logo":"./data/images/clubs/ParquePatricios.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcosDiaz0.json
// module id = 2758
// module chunks = 0